// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0f725c32","147":"48198676","448":"53a2e227","574":"6c85020d","807":"a689964d","818":"a5f842bb","899":"5e0641cb","900":"815301c4","996":"066f4005"}[chunkId] + ".chunk.js";
};